import styled from "styled-components";
import { typographyMixin } from "../../typography";

export const CardContainer = styled.div.attrs({
  className: "card-container",
})`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.75rem;
  box-shadow: 0px 4px 4px 0px rgba(54, 56, 61, 0.2);
  border-radius: 0.3125rem;
  ${typographyMixin};
`;

export const StyledCard = styled.div.attrs({ className: "card" })<{ hasFooter: boolean; size: "sm" | "lg" }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #404247;
  font-size: 1rem;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  border-radius: 0.3125rem;
  border-bottom-right-radius: ${(props) => (props.hasFooter ? "0rem" : "0.3125rem")};
  border-bottom-left-radius: ${(props) => (props.hasFooter ? "0rem" : "0.3125rem")};
  background: #fff;
  padding: 0.25rem 0.75rem;
  min-height: ${(props) => (props.size === "sm" ? "2.5rem" : "4.6rem")};
`;

export const CardContentWrapper = styled.div.attrs({ className: "card-content-container" })`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardImg = styled.img`
  object-fit: contain;
  max-width: 50px;
  max-height: 50px;
  margin-right: 0.25rem;
`;

export const CardContent = styled.div.attrs({ className: "card-content" })`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const CardText = styled.div.attrs({ className: "card-text" })`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardContentHeader = styled.div.attrs({ className: "card-content-header" })`
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #36383d;
`;

export const CardIconContaner = styled.div.attrs({ className: "card-icon-container" })`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .card-checkbox-color {
    background-color: #d7d7d8;
  }

  .form-switch .form-check-input {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386888B'/%3e%3c/svg%3e");
  }

  .card-checkbox-color:checked {
    background-color: ${(props) => props.theme.primaryColor};
    border-color: ${(props) => props.theme.primaryColor};
  }
  .card-checkbox-color:focus {
    border-color: ${(props) => props.theme.primaryColor};
    box-shadow: ${(props) => `0 0 3px 2px ${props.theme.primaryColor}`};
  }

  .form-switch .form-check-input:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
  }
`;

export const CheckmarkContainer = styled.div.attrs({ className: "card-checkmark-container" })`
  color: #36383d;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  flex-direction: row;
`;

export const StyledIcon = styled.img.attrs({ className: "card-icon" })`
  object-fit: contain;
  max-width: 20px;
`;

export const BarFooter = styled.div.attrs({ className: "card-footer" })`
  border-radius: 0rem 0rem 0.3125rem 0.3125rem;
  background: #d7d7d8;
  color: #36383d;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0.5rem 0;
  text-align: center;
`;
